import cx from 'classnames'

import { UrgentIcon } from '../../../../assets/svgs/components'
import { DatePicker } from '../../../shared/NarusMaterial'
import selectsStyles from '../../components/selects/select.module.scss'

import styles from './datapicker.module.scss'

export function DatapickerUrgent ({
  value,
  urgent,
  handleChangeDate,
  add = false,
  handleChangeUrgent
}) {
  return (
    <div className={cx(styles.daysAction, 'date-picker')}>
      <div className={styles.selects}>
        <div className={cx(selectsStyles.itemsWrapper, selectsStyles.editable)}>
          <div className={cx(selectsStyles.typeSelect, selectsStyles.date, styles.datePicker)}>
            <DatePicker
              onChange={date => handleChangeDate(date)}
              label=''
              value={value}
              onBlur={() => ({})}
            />
          </div>
        </div>
      </div>
      <div
        className={cx(styles.urgent, styles.content, { [styles.add]: add })}
        style={{
          padding: '0',
          borderRadius: '8px'
        }}
      >
        <UrgentIcon
          onClick={() => handleChangeUrgent('urgent', !urgent)}
          title='Urgent'
          fill={urgent ? '#FF5741' : '#9a9797'}
        />
      </div>
    </div>
  )
}
